import { useState } from "react";
import styles from "./PinHint.module.css";

const DISMISSED_KEY = "aiva_pin_hint_dismissed";

function loadDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
}

function persistDismissed() {
  try {
    localStorage.setItem(DISMISSED_KEY, "1");
  } catch { /* storage unavailable */ }
}

export function PinHint() {
  const [dismissed, setDismissed] = useState<boolean>(loadDismissed);

  if (dismissed) return null;

  const handleDismiss = () => {
    persistDismissed();
    setDismissed(true);
  };

  return (
    <output className={styles.banner}>
      <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 17v5" />
        <path d="M9 10.76V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4.76a2 2 0 0 0 1.11 1.79l1.78.89A2 2 0 0 1 19 13.24V15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-1.76a2 2 0 0 1 1.11-1.79l1.78-.89A2 2 0 0 0 9 10.76z" />
      </svg>
      <span className={styles.message}>
        Pin AiVA from the task pane header to keep your chat across emails
      </span>
      <button
        type="button"
        className={styles.dismiss}
        onClick={handleDismiss}
        aria-label="Dismiss pin reminder"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </output>
  );
}
